import styled from '@emotion/styled';
import { Link } from 'components/link';
import { Text } from 'ds/components/typography';
import { colorToAlpha } from 'helpers/insight';
import { CommonWrapper } from 'screens/AgentOfficePages/styled';


const CARD_SIZE = 360;

export const SectionWrapper = styled(CommonWrapper)<{ isMobile?: boolean }>`
  .item-wrapper {
    padding: 0 ${({ theme }) => theme.spacing(2)};
  }
  .item-wrapper:first-of-type {
    padding-right: ${({ theme }) => theme.spacing(3)};
  }
  .item-wrapper:last-of-type {
    padding-left: ${({ theme }) => theme.spacing(3)};
  }
  ${({ theme }) => theme.media.showAt({ from: 3 })`
    .item-wrapper:first-of-type {
      padding-right: ${theme.spacing(8)};
    }
    .item-wrapper:last-of-type {
      padding-left: ${theme.spacing(8)};
    }
  `}
  ${({ isMobile }) => isMobile ? `
    && {
      padding: 0;
    }
  ` : ''}
`;

export const LessThanScreenWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(4)};
  > a {
    margin: 0;
  }
`;

export const ItemWrapper = styled(Link)<{ isSingle?: boolean }>`
  width: ${CARD_SIZE}px;
  position: relative;
  margin: 0 ${({ theme }) => theme.spacing(2)};
  border: 1px solid ${({ theme }) => theme.colors.neutrals.grey8};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  overflow: hidden;
  line-height: 0;
  display: block;
  height: ${({ isSingle }) => isSingle ? 'auto' : '360px'};
  img {
    object-fit: cover;
    width: ${CARD_SIZE}px;
    height: ${CARD_SIZE}px;
    user-select: none;
  }
  ${({ isSingle }) => isSingle ? `
    margin: 0;
    width: 100%;
    img {
      width: 100%;
    }
  ` : ''}
`;

export const InfinityItemWrapper = styled(ItemWrapper)`
  margin: 0;
`;

export const ItemTitle = styled(Text)`
  position: absolute;
  bottom: 0;
  left: 0;
  height: 48px;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
  line-height: 48px;
  color: ${({ theme }) => theme.colors.neutrals.white};
  text-align: center;
  max-width: 100%;
  padding: 0 ${({ theme }) => theme.spacing(3)};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
`;

export const CarouselWrapper = styled.div`
  position: relative;
  .arrows {
    display: none;
  }
  :hover .arrows {
    display: block;
  }
`;

const ArrowBase = styled.div`
  position: absolute;
  top: 50px;
  bottom: 0;
  width: 96px;
  user-select: none;
  cursor: pointer;
  svg {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
`;

export const ArrowLeftWrapper = styled(ArrowBase)<{ grayShadow: boolean }>`
  left: 0;
  background: ${({ theme, grayShadow }) => `linear-gradient(-90deg, ${colorToAlpha(theme.colors.neutrals.grey9, 0)} 0%, ${grayShadow ? theme.colors.neutrals.grey11 : theme.colors.neutrals.white} 84.65%)`};
  svg {
    left: 12px;
  }
`;

export const ArrowRightWrapper = styled(ArrowBase)<{ grayShadow: boolean }>`
  right: 0;
  background: ${({ theme, grayShadow }) => `linear-gradient(90deg, ${colorToAlpha(theme.colors.neutrals.grey9, 0)} 0%, ${grayShadow ? theme.colors.neutrals.grey11 : theme.colors.neutrals.white} 84.65%)`};
  svg {
    right: 12px;
  }
`;
